import {Grid, Typography, Divider, Skeleton} from "@mui/material"
import {FC} from "react"
import {
  formatDateMMDDYYYY,
  MonthFormat,
} from "../../../helpers/formatDateLongMonth"
import {ThoughtPiecesAuthorModel} from "../../../types/ThoughtPiecesModel"
import React from "react"
import Author from "../../atoms/author/Author"

type Props = {
  articleTitle?: string
  title?: string
  date?: string
  authors?: ThoughtPiecesAuthorModel[]
  tags?: string[]
  loading: boolean
}

const ArticleDetails: FC<Props> = ({
  articleTitle,
  title,
  date,
  authors,
  tags,
  loading,
}) => {
  return (
    <>
      <Grid size={12} display="flex" flexDirection="column" rowGap="8px">
        <Grid
          size={12}
          gap={1}
          direction="row"
          display="flex"
          flexWrap="wrap"
          justifyContent={"flex-start"}
          alignItems="center"
        >
          {loading ? (
            <>
              <Skeleton
                variant="rectangular"
                width={96}
                height={16}
                sx={{
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
              <Divider
                color="#242d35"
                orientation="vertical"
                variant="middle"
                flexItem
                style={{height: "8.9px"}}
              />
              <Skeleton
                variant="rectangular"
                width={96}
                height={16}
                sx={{
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
              <Divider
                color="#242d35"
                orientation="vertical"
                variant="middle"
                flexItem
                style={{height: "8.9px"}}
              />
              <Skeleton
                variant="rectangular"
                width={96}
                height={16}
                sx={{
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
            </>
          ) : (
            <>
              <Typography
                color="#242d35"
                style={{fontSize: "14px", lineHeight: "20px"}}
                variant="caption"
              >
                {title}
              </Typography>
              <Divider
                color="#242d35"
                orientation="vertical"
                variant="middle"
                flexItem
                style={{height: "8.9px"}}
              />
              <Typography
                color="#242d35"
                style={{fontSize: "14px", lineHeight: "20px"}}
                variant="caption"
              >
                {date
                  ? formatDateMMDDYYYY(new Date(date), MonthFormat.Long)
                  : null}
              </Typography>
              {authors &&
                authors.length > 0 &&
                authors.map((author) => (
                  <React.Fragment key={author.group}>
                    <Divider
                      color="#242d35"
                      orientation="vertical"
                      variant="middle"
                      flexItem
                      style={{height: "8.9px"}}
                    />
                    <Author authorId={author.group} origin={articleTitle!}>
                      <Typography
                        style={{
                          fontSize: "14px",
                          lineHeight: "20px",
                          color: "#226ca6",
                          textDecoration: "underline",
                        }}
                        variant="caption"
                      >
                        {author.name}
                      </Typography>
                    </Author>
                  </React.Fragment>
                ))}
            </>
          )}
        </Grid>
        <Grid
          size={12}
          gap={1}
          direction="row"
          display="flex"
          flexWrap="wrap"
          justifyContent={"flex-start"}
          alignItems="center"
        >
          {loading ? (
            <>
              <Skeleton
                variant="rectangular"
                width={96}
                height={16}
                sx={{
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
              <Divider
                color="#242d35"
                orientation="vertical"
                variant="middle"
                flexItem
                style={{height: "8.9px"}}
              />
              <Skeleton
                variant="rectangular"
                width={96}
                height={16}
                sx={{
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
              <Divider
                color="#242d35"
                orientation="vertical"
                variant="middle"
                flexItem
                style={{height: "8.9px"}}
              />
              <Skeleton
                variant="rectangular"
                width={96}
                height={16}
                sx={{
                  backgroundImage:
                    "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                }}
              />
            </>
          ) : (
            <>
              {!loading &&
                tags &&
                tags.length > 0 &&
                tags.map((item, index) => (
                  <>
                    <Typography
                      color="#242d35"
                      style={{fontSize: "14px", lineHeight: "20px"}}
                      variant="caption"
                    >
                      {item}
                    </Typography>
                    {index !== tags.length - 1 && (
                      <Divider
                        color="#242d35"
                        orientation="vertical"
                        variant="middle"
                        flexItem
                        style={{height: "8.9px"}}
                      />
                    )}
                  </>
                ))}
            </>
          )}
        </Grid>
      </Grid>
      <Divider
        style={{
          borderColor: "rgb(189,189,188)",
          marginTop: "15.5px",
        }}
        orientation="horizontal"
        variant="fullWidth"
        flexItem
      />
    </>
  )
}

export default ArticleDetails
